import { useState } from "react";
import { supabase } from "@/libs/supabase";
import { useAuth } from "../useAuth";

export const useDeleteComment = () => {
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();

	const deleteComment = async (commentId: string) => {
		if (!user) throw new Error("認証が必要です");

		setLoading(true);
		try {
			const { error } = await supabase
				.from("comments")
				.delete()
				.eq("id", commentId)
				.eq("user_id", user.id);

			if (error) throw error;
		} finally {
			setLoading(false);
		}
	};

	return { deleteComment, loading };
};
